module.exports = __webpack_public_path__ + "static/media/portfolio.1e139d92.png";